export default __webpack_public_path__ + "static/media/prototypee.f4066e64.png";